<template>
  <v-card class="mx-auto my-12" max-width="400">
    <template slot="progress">
      <v-progress-linear
          color="deep-purple"
          height="10"
          indeterminate
      ></v-progress-linear>
    </template>

    <v-img
        v-if="licence.course.imageRef"
        height="250"
        :src="licence.course.imageRef"
    />

    <v-card-title style="word-break: break-word;">{{
        licence.course.title
      }}
    </v-card-title>

    <v-card-text>
      <v-row align="center" class="mx-0">
        <v-chip v-if="licence.amountOpen>0" class="ma-2" color="primary" label>
          <v-icon left>mdi-account-circle-outline</v-icon>
          {{ licence.amountOpen }} Offen
        </v-chip>
        <v-chip v-if="licence.amountSpent>0" class="ma-2" color="secondary" label>
          <v-icon left>mdi-account-circle-outline</v-icon>
          {{ licence.amountSpent }} Vergeben
        </v-chip>
        <v-chip v-if="licence.amountPlanned>0" class="ma-2" color="info" label>
          <v-icon left>mdi-account-circle-outline</v-icon>
          {{ licence.amountPlanned }} Verplant
        </v-chip>
      </v-row>
    </v-card-text>

    <v-btn
        color="info"
        style="margin: 0; width: 100%;"
        @click="$emit('details')"
    >
      Schulung verwalten
    </v-btn>

    <v-expansion-panels>
      <v-expansion-panel>
        <v-expansion-panel-header>
          Kaufhistorie
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="licence.purchases.length===0">Keine Lizenzen gefunden</div>
          <div v-for="purchase in filteredPurchases" :key="purchase.date">
            <v-row align="end" justify-end>
              <v-col style="padding: 0">
                <v-list-item two-line>
                  <v-list-item-content>
                    <v-list-item-title v-if="purchase.amount===1">{{ purchase.amount }} Lizenz</v-list-item-title>
                    <v-list-item-title v-else>{{ purchase.amount }} Lizenzen</v-list-item-title>
                    <v-list-item-subtitle>{{ purchase.date | moment("DD.MM.YYYY HH:mm") }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-col>
              <v-col align-self="stretch" style="text-align: end; align-self: end; align-content: end">
                <v-chip class="ma-2" label :color="purchase.colorForReason" text-color="white">
                  {{ purchase.textForReason }}
                </v-chip>
              </v-col>
            </v-row>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel v-if="superAdmin">
        <v-expansion-panel-header>
          Lizenzen erhöhen
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <p>Negativer Wert, um Lizenzen zu entfernen, positiver um Lizenzen hinzuzufügen.</p>
          <v-slider
              style="margin-top: 48px"
              v-model="slider"
              class="align-center"
              :max="max"
              :min="min"
              thumb-label="always"
              hide-details
          >
            <template v-slot:append>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      :disabled="loading"
                      @click="assign"
                      class="ma-2"
                      outlined
                      x-small
                      fab
                      color="indigo"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon>mdi-arrow-right</v-icon>
                  </v-btn>
                </template>
                <span>Lizenzen verteilen</span>
              </v-tooltip>
            </template>
          </v-slider>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <v-snackbar :timeout="5000" :value="error" color="error" left shaped top app>{{ errorText }}</v-snackbar>
    <v-snackbar :timeout="5000" :value="success" color="primary" left shaped top app>{{ successText }}</v-snackbar>
  </v-card>
</template>

<script>
import License from "@/models/License";

export default {
  name: "CompanyLicenceItem",
  props: {
    licence: {
      type: License
    },
    superAdmin: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    slider: 0,
    errorText: "",
    successText: "",
    max: 50,
    hideAssignments: true,
    loading: false,
    error: false,
    success: false
  }),
  computed: {
    min() {
      if (this.licence.amountOpen < 1) return 0
      else return this.licence.amountOpen * -1;
    },
    filteredPurchases() {
      return this.licence.purchases.filter((date) => (!this.hideAssignments || !date.isAssignment))
    },
    openUsers() {
      return this.licence.licenceUsers.filter((user) => {
        return user.isOpen;
      })
    },
    plannedUsers() {
      return this.licence.licenceUsers.filter((user) => {
        return user.isPlanned;
      })
    },
    takenUsers() {
      return this.licence.licenceUsers.filter((user) => {
        return user.isTaken;
      })
    }
  },
  methods: {
    assign() {
      this.loading = true;
      this.$httpLicenseApi.setManualCourseValue(this.licence.companyId, this.licence.course.id, this.slider, () => {
        this.loading = false;
        this.successText = "Lizenzen zugewiesen";
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.$emit("reload")
      }, (error) => {
        this.loading = false;
        this.errorText = "Fehler: " + error;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    addItem(licenceUser) {
      this.loading = true;
      this.$httpCourseRunApi.assign(this.superAdmin ? this.licence.companyId : null, this.licence.course.id, [licenceUser.id],
          () => {
            this.loading = false;
            this.successText = "Kurs zugewiesen";
            this.success = true;
            setTimeout(() => this.success = false, 3000);
            this.$emit("reload")
          }, (error) => {
            this.loading = false;
            this.errorText = "Fehler: " + error;
            this.error = true;
            setTimeout(() => this.error = false, 5000);
          })
    },
    reassign(licenceUser) {
      this.loading = true;
      this.$httpCourseRunApi.reassign(this.superAdmin ? this.licence.companyId : null, this.licence.course.id, [licenceUser.id],
          () => {
            this.loading = false;
            this.successText = "Kurs erneut zugewiesen";
            this.success = true;
            setTimeout(() => this.success = false, 3000);
            this.$emit("reload")
          }, (error) => {
            this.loading = false;
            this.errorText = "Fehler: " + error;
            this.error = true;
            setTimeout(() => this.error = false, 5000);
          })
    },
    restartItem(user) {
      this.loading = true;
      this.$httpUserApi.resetCourseProgress(user.id, user.courseRunId, () => {
        this.loading = false;
        this.successText = "Fortschritt zurückgesetzt";
        this.success = true;
        setTimeout(() => this.success = false, 3000);
        this.$emit("reload")
      }, (error) => {
        this.loading = false;
        this.errorText = "Fehler: " + error;
        this.error = true;
        setTimeout(() => this.error = false, 5000);
      })
    },
    removeItem(licenceUser) {
      this.loading = true;
      this.$httpCourseRunApi.remove(this.superAdmin ? this.licence.companyId : null, this.licence.course.id, [licenceUser.id],
          () => {
            this.loading = false;
            this.successText = "Kurs zugewiesen";
            this.success = true;
            setTimeout(() => this.success = false, 3000);
            this.$emit("reload")
          }, (error) => {
            this.loading = false;
            this.errorText = "Fehler: " + error;
            this.error = true;
            setTimeout(() => this.error = false, 5000);
          })
    },
    downloadItem(licenceUser) {
      this.$httpDownloadApi.download(licenceUser.certificateLink, "Zertifikat");
    }
  }
}
</script>

<style scoped>

</style>
